document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('a[href^="#"]').forEach(a=>a.addEventListener('click',e=>{
    const target=document.querySelector(a.getAttribute('href'));
    if(target){e.preventDefault();target.scrollIntoView({behavior:'smooth'});}
  }));

  document.querySelectorAll('[data-inventory-slider]').forEach(initInventorySlider);
});

function initInventorySlider(slider){
  const viewport=slider.querySelector('[data-inventory-viewport]');
  const track=slider.querySelector('[data-inventory-track]');
  const prev=slider.querySelector('[data-inventory-prev]');
  const next=slider.querySelector('[data-inventory-next]');
  if(!viewport||!track) return;

  // Shuffle the initial Shopify products so the homepage feels fresh on each visit.
  const items=[...track.querySelectorAll('.hero-product:not(.hero-product-demo)')];
  if(items.length>1){
    for(let i=items.length-1;i>0;i--){
      const j=Math.floor(Math.random()*(i+1));
      [items[i],items[j]]=[items[j],items[i]];
    }
    items.forEach(item=>track.appendChild(item));
  }

  const pageStep=()=>Math.max(260,viewport.clientWidth*.92);
  prev?.addEventListener('click',()=>viewport.scrollBy({left:-pageStep(),behavior:'smooth'}));
  next?.addEventListener('click',()=>viewport.scrollBy({left:pageStep(),behavior:'smooth'}));

  let isDown=false,startX=0,startScroll=0;
  viewport.addEventListener('pointerdown',e=>{
    isDown=true;startX=e.clientX;startScroll=viewport.scrollLeft;
    viewport.classList.add('is-dragging');
    viewport.setPointerCapture?.(e.pointerId);
  });
  viewport.addEventListener('pointermove',e=>{if(isDown) viewport.scrollLeft=startScroll-(e.clientX-startX);});
  const release=()=>{isDown=false;viewport.classList.remove('is-dragging')};
  viewport.addEventListener('pointerup',release);
  viewport.addEventListener('pointercancel',release);
  viewport.addEventListener('pointerleave',release);

  // Keep loading additional products from the collection as shoppers move through the rail.
  const handle=slider.dataset.collectionHandle||'all';
  const seen=new Set([...track.querySelectorAll('[data-product-handle]')].map(el=>el.dataset.productHandle));
  let page=1,loading=false,finished=false;

  async function loadMore(){
    if(loading||finished||track.querySelector('.hero-product-demo')) return;
    loading=true;
    try{
      const res=await fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=250&page=${page}`,{headers:{'Accept':'application/json'}});
      if(!res.ok){finished=true;return;}
      const data=await res.json();
      const products=Array.isArray(data.products)?data.products:[];
      if(!products.length){finished=true;return;}
      let added=0;
      products.forEach(product=>{
        if(seen.has(product.handle)) return;
        seen.add(product.handle);added++;
        const a=document.createElement('a');
        a.className='hero-product';a.href=`/products/${product.handle}`;a.dataset.productHandle=product.handle;
        const image=product.images&&product.images[0]?`<img loading="lazy" src="${escapeHtml(product.images[0].src)}" alt="${escapeHtml(product.title)}">`:`<div class="hero-product-placeholder"><span>FSA</span><small>BOOKS</small></div>`;
        const variant=product.variants&&product.variants[0];
        const price=variant&&variant.price?formatPrice(variant.price):'';
        a.innerHTML=`<div class="hero-product-cover">${image}</div><div class="hero-product-info"><strong>${escapeHtml(product.title)}</strong><span>${escapeHtml(price)}</span></div>`;
        track.appendChild(a);
      });
      page++;
      if(products.length<250) finished=true;
      if(!added&&finished) return;
    }catch(err){finished=true;}
    finally{loading=false;}
  }

  // Fill beyond the first Liquid batch, then continue lazily near the end.
  loadMore();
  viewport.addEventListener('scroll',()=>{
    if(viewport.scrollLeft+viewport.clientWidth>viewport.scrollWidth-viewport.clientWidth*2) loadMore();
  },{passive:true});
}

function formatPrice(value){
  const n=Number(value);
  if(Number.isNaN(n)) return value||'';
  try{return new Intl.NumberFormat(undefined,{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD'}).format(n)}catch(e){return `$${n.toFixed(2)}`}
}
function escapeHtml(value=''){
  return String(value).replace(/[&<>'"]/g,ch=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[ch]));
}
